import { render } from "./ForceChangePassword.vue?vue&type=template&id=3faf3878&scoped=true"
import script from "./ForceChangePassword.vue?vue&type=script&lang=js"
export * from "./ForceChangePassword.vue?vue&type=script&lang=js"

import "./ForceChangePassword.vue?vue&type=style&index=0&id=3faf3878&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3faf3878"]])

export default __exports__